import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { LigneCommande } from './ligne-commande';

@JsonObject
export class Commande {
  constructor (
    numTiers?: string,
    numeroCommande?: string,
    lignes?: LigneCommande[]
  ) {
    this.numTiers = numTiers;
    this.numeroCommande = numeroCommande;
    this.lignes = lignes;
  }

  @JsonProperty(String)
  numTiers?: string;

  @JsonProperty(String)
  @Optional
  numeroCommande?: string;

  @JsonProperty([LigneCommande])
  lignes?: LigneCommande[];
}
